<template>
    <div>
        <div class="cart__delivery-notice">
            При сумме заказа с учетом скидок от {{ freeDeliverySum }} руб. доставка 2–14 руб. в зависимости от региона
        </div>
        <div class="cart__outlet-notice" v-if="outletBasketTypes.length > 1">
            В корзине есть товары из раздела Outlet. Эти товары будут помещены в отдельный заказ.
        </div>
        <div class="cart__outlet-notice" v-if="deleteNotAvailable.length > 0">
          Товары закончились и были удалены
          <div class="cart__outlet-notice__item" v-for="deleteItem in deleteNotAvailable">{{ deleteItem }}</div>
        </div>

        <template v-if="basketItems.length">
            <!-- TODO
            <a href="javascript:;" class="cart__signboard" title="Подсказка баннера">
                <picture class="cart__signboard-pic picture">
                    <source media="(max-width: 414px)" data-srcset="../../images/content/banner_1_414.jpg">
                    <img class="picture__img lazyload" data-src="../../images/content/banner_1.jpg" data-sizes="976" alt="">
                </picture>
            </a>
            -->

            <basket-items-list v-for="(outlet, index) in outletBasketTypes" :key="index" :freeDeliverySum="freeDeliverySum"
                               :outlet="outlet" :index="index + 1" :show-title="outletBasketTypes.length > 1"
                               :show-coupons="outlet <= 0">
            </basket-items-list>

            <div class="cart-total">
                <div class="cart-total__wrapper">
                    <div class="cart-total__block">
                        <p class="cart-total__caption">Сумма заказа</p>
                        <p class="cart-total__price" :inner-html.prop="total.basePrice | price"></p>
                    </div>

                    <svg class="icon icon--circle_minus cart-total__minus">
                        <use xlink:href="#icon-circle_minus"></use>
                    </svg>

                    <div class="cart-total__block">
                        <p class="cart-total__caption">Скидка</p>

                        <svg class="icon icon--circle_minus cart-total__minus-mobile">
                            <use xlink:href="#icon-circle_minus"></use>
                        </svg>

                        <p class="cart-total__price" :inner-html.prop="total.discount | price"></p>
                    </div>

                    <svg class="icon icon--circle_equals cart-total__equals">
                        <use xlink:href="#icon-circle_equals"></use>
                    </svg>

                    <p class="cart-total__caption cart-total__separate">Итого</p>

                    <p class="cart-total__sum cart-total__separate" :inner-html.prop="total.totalPrice | price"></p>
                </div>
            </div>

            <div class="cart__btn-container">
                <button class="btn btn--blue cart__btn" type="button" @click="setCurrentTab('basket-order')" :disabled="isDisableBtn">
                    Продолжить
                </button>
            </div>
        </template>
        <div v-else>
            <div class="cart__empty-message">
                <svg class="icon icon--cart cart__empty-message-icon">
                    <use xlink:href="#icon-cart"></use>
                </svg>
                <p class="cart__empty-message-text">Ваша корзина пуста</p>
            </div>
        </div>
    </div>
</template>

<script>
import basketItem from './basketItem.vue';
import basketItemsList from './basketItemsList.vue';
import { mapState, mapGetters, mapActions } from 'vuex';
import freeDeliveryMixin from '../freeDelivery';
import outletMixin from '../outlet';

export default {
    name: 'basket',
    components: { basketItem, basketItemsList },
    computed: {
        ...mapState(['basketItems', "outletMinPrice", "maxCount", 'total', 'deleteNotAvailable']),
        ...mapGetters(['getTotalPrice']),
        isDisableBtn () {
          let price = {};
          let count = {};
          this.basketItems.forEach(item=>{
            let index = item.outlet ? item.outlet : 'base';
            if (price[index] === undefined) {
              price[index] = 0;
              count[index] = 0;
            }
            price[index] += 1 * item.finalPrice;
            if(item.finalPrice>0) {
              count[index] += 1 * item.qnt;
            }
          });
          for(let i in price) {
            if (price[i] < this.outletMinPrice || count[i] > this.maxCount) {
              return true;
            }
          }
          return false;
        }
    },
    methods: {
        ...mapActions(['setCurrentTab']),
    },
    mixins: [
        freeDeliveryMixin,
        outletMixin,
    ],
};
</script>